export default __webpack_public_path__ + "static/media/Char2.a947d7db.png";